import React from "react";
import { useAuth } from "../context/AuthContext";

const UserTopbar = ({ title }) => {
  const { user } = useAuth();

  // Extract tenant identifier
  const tenantId = localStorage.getItem("adminId") || (user && user.adminId) || "global";
  const activeTenant = "";

  const displayId = user?.node_id || (user?._id ? user._id.toString().slice(-6).toUpperCase() : `${activeTenant}-N/A`);

  const handleGuideClick = () => {
    window.location.href = '/manual';
  };

  return (
    <nav style={styles.navStyle} data-tenant-scope={tenantId}>
      <div style={styles.navContainer}>
        {/* LEFT SECTION: Title + Name & ID positioned at the bottom left */}
        <div style={styles.navLeftSection}>
          <div style={styles.navSubTitle} className="glow-text"> {activeTenant}</div>
          <h1 style={styles.navTitle}>{title}</h1>

          {/* User info moved to bottom-left */}
          <div style={styles.userLeftContainer}>
            <div style={styles.navUserName}>
              {user?.name || "It's Nishu"}
            </div>
            <div style={styles.navUserId}>
              {displayId}
            </div>
          </div>
        </div>

        {/* RIGHT SECTION: Read Me Button */}
        <div style={styles.navRightSection}>
          <button 
            onClick={handleGuideClick} 
            className="glowing-border-btn"
            style={styles.guideButton}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.15)';
              e.currentTarget.style.transform = 'scale(1.04)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <span style={styles.guideIcon}></span>
            <span style={styles.guideText}>READ ME</span>
          </button>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Playfair+Display:ital,wght@0,600;1,600&display=swap');

        @keyframes neonGlow { 
          0% { text-shadow: 0 0 5px #6D9BC3; } 
          50% { text-shadow: 0 0 15px #6D9BC3; } 
          100% { text-shadow: 0 0 5px #6D9BC3; } 
        }

        /* Pulsing Glow Indicator animation for the READ ME button */
        @keyframes borderPulse {
          0% {
            border-color: #EF4444;
            box-shadow: 0 0 4px rgba(239, 68, 68, 0.4), inset 0 0 4px rgba(239, 68, 68, 0.2);
          }
          50% {
            border-color: #FF2E2E;
            box-shadow: 0 0 14px rgba(239, 68, 68, 0.85), inset 0 0 8px rgba(239, 68, 68, 0.4);
          }
          100% {
            border-color: #EF4444;
            box-shadow: 0 0 4px rgba(239, 68, 68, 0.4), inset 0 0 4px rgba(239, 68, 68, 0.2);
          }
        }

        .glow-text { 
          animation: neonGlow 2s infinite; 
          color: #6D9BC3 !important; 
        }

        .glowing-border-btn {
          animation: borderPulse 1.8s infinite ease-in-out;
        }
      `}</style>
    </nav>
  );
};

const styles = {
  navStyle: { 
    position: "fixed", top: 0, left: 0, right: 0, height: "155px", 
    backgroundColor: "#fbf9f5", 
    backgroundImage: "url('/topbarimage.png')",
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    zIndex: 1000, 
    color: "#2c3e50", 
    display: "flex", 
    flexDirection: "column", 
    borderBottom: "1px solid rgba(0,0,0,0.1)", 
    overflow: "hidden",
    width: "100vw"
  },
  navContainer: { 
    width: "100%", 
    maxWidth: "100%", 
    height: "100%",
    margin: "0 auto", 
    padding: "18px 35px 15px 35px", 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "flex-end", 
    position: 'relative', 
    zIndex: 2,
    boxSizing: "border-box"
  },
  navLeftSection: { 
    display: "flex", 
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%"
  },
  navSubTitle: { fontSize: "10px", letterSpacing: "2px", fontWeight: "900", marginBottom: '2px' },
  navTitle: { fontSize: "20px", fontWeight: "800", margin: 0, letterSpacing: '-0.5px', color: '#111' },
  
  userLeftContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto'
  },
  navUserName: { 
    fontWeight: "800", 
    fontSize: "26px", 
    fontFamily: "'Great Vibes', 'Playfair Display', cursive, serif", 
    color: '#111',
    lineHeight: '1.1'
  },
  navUserId: { 
    fontSize: "15px", 
    fontWeight: "800", 
    fontFamily: "'Space Mono', monospace", 
    color: '#444', 
    letterSpacing: '0.5px'
  },
  
  navRightSection: {
    display: 'flex',
    alignItems: 'flex-end',
    height: '100%',
    paddingBottom: '5px'
  },
  guideButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '6px 14px',
    backgroundColor: 'transparent',
    border: '3.5px solid #EF4444',
    borderRadius: '60px',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  },
  guideIcon: { fontSize: '12px' },
  guideText: { 
    color: '#EF4444', 
    fontSize: '13px', 
    fontWeight: '900', 
    textTransform: 'uppercase',
    letterSpacing: '0.8px'
  },
};

export default UserTopbar;